import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import store from '../src/store'
import { connect } from "react-redux";
import StateCountyCity from '../src/statecountycity'
import HotLinks from '../src/HotLinks'
import ABCs from '../src/ABCs'
import SearchLocationLine from '../src/SearchLocationLine'
import CategorySelection from '../src/CategorySelection'
import CategoryTabs from '../src/CategoryTabs'
import CategoryManagement from '../src/CategoryManagement'
import MyClassifieds from '../src/MyClassifieds'
import ManageAdvertisers from '../src/manageListings/advertisers'
import WhatsForDinner from '../src/WhatsForDinner'
import Listings from '../src/Listings'
import SavedListingsLinks from '../src/SavedListingsLinks'
import ItsOver from '../src/ItsOver'
import HeaderSlot from '../src/HeaderSlot'
import Explain from '../src/Explain'
import EditSplash from '../src/EditSplash'
import TemplateEditor from '../src/TemplateEditor'
import EditSitePage from '../src/EditSitePage'
import SignUpBusiness from '../src/SignUpBusiness'
import AccountAdmin from '../src/advertiser_pages/AccountAdmin'
import AccountAdmin2 from '../src/advertiser_pages2/AccountAdmin'
import JOOC from '../src/JOOC'
import { getPageContents } from './apis'
import { changeSitePage, resetSearch } from './actions/index'
import { CHANGE_LISTING_ID } from './constants/action-types'
import Splashpage from '../src/Splashpage'
import AdjacentCounties from '../src/AdjacentCounties'
import CheckThisOut from '../src/CheckThisOut'
import MetroCities from '../src/MetroCities'
import Guts from '../src/Guts'
import Footer from '../src/Footer'
import { modeToListingIDs } from './Modes'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const _JOOC = 'Jewel on our Crown'

const styles = {
    font: {
        //fontFamily: '"Segoe UI", SegoeUI, "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: '15px',
    },
    accordionSummary: {
        flexDirection: 'row-reverse',
        minHeight: '20px !important',
        height: '20px !important',
    }
}

const pages = {
    'CategoryManagement': CategoryManagement,
    'MyClassifieds': MyClassifieds,
    'ManageListings': ManageAdvertisers,
    'EditSplash': EditSplash,
    'EditSitePage': EditSitePage,
    'TemplateEditor': TemplateEditor,
    'AccountAdmin': AccountAdmin,
    'AccountAdmin2': AccountAdmin2,
}

const pagesPlusHeader = {
    'SignUpBusiness': SignUpBusiness,
}

class Page extends React.Component {
    constructor(props, classes) {
        super(props)
        this.state = {
            contents: '',
            header: true,
            page_name: 'Home Page',
            expanded: true,
        }
        this.count = 0
    }

    componentWillReceiveProps = function (nextProps) {
        const { classes } = this.props
        if (nextProps.site_page && (pagesPlusHeader[nextProps.site_page] || pages[nextProps.site_page])) {
//            let content = pagesPlusHeader[nextProps.site_page] ? pagesPlusHeader[nextProps.site_page] : pages[nextProps.site_page]
            this.setState({ header: nextProps.site_page in pagesPlusHeader })
        }
    }

    expandClicked = () => {
        this.setState({ expanded: !this.state.expanded })
    }

    mobileCheck = function () {
        let check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    };

    componentDidMount = function () {
        const { classes } = this.props
        if ( this.mobileCheck() ) alert('MyOCG.com is best viewed on a desktop or laptop.  We are still developing this site and have not built the mobile version yet.  You can continue, but this is not the final look of the site.')


        this.count = this.count + 1
        this.setState({ contents: <Splashpage key={'homepage'} k={this.count} listing_id={0} page_name='Home Page' /> })
        //     this.setState({ contents: <Accordion expanded={this.state.expanded} onChange={this.expandClicked}>
        //         <AccordionSummary
        //             className={classes.accordionSummary}
        //           expandIcon={<ExpandMoreIcon />}
        //         >Testing!!</AccordionSummary>
        //         <AccordionDetails>
        // <Splashpage key={'homepage'} k={this.count} listing_id={0} page_name='Home Page' />
        // </AccordionDetails>
        // </Accordion>
        //  })
    }

    setPageName = (page_name) => {
        this.setState({ page_name })
    }

    changePage = (page) => {
        store.dispatch(changeSitePage(page))
    }

    render() {
        const { classes } = this.props;
        window.changePage = this.changePage.bind(this);
        let adjacentcounties = <AdjacentCounties />
        if (this.state.header) {
            return (
                <div className={classes.font}>
                    <StateCountyCity style={{ float: 'left', clear: 'both' }} />
                    <HotLinks style={{ float: 'left' }} />
                    <div style={{ display: 'block', clear: 'both', float: 'left', width: '314px' }}>
                        <ABCs style={{ float: 'left', clear: 'both' }} />
                        <CategorySelection style={{ float: 'left' }} />
                    </div>
                    <div style={{ float: 'left' }}>
                        <ItsOver style={{ display: 'block' }} />
                    </div>
                    <div style={{ float: 'left', height: '100px', float: 'left', width: '500px', marginLeft: '-500px', paddingTop: '40px' }}>
                        <HeaderSlot />
                    </div>
                    <SearchLocationLine style={{ clear: 'both', float: 'left' }} />
                    <WhatsForDinner style={{ float: 'left' }} />
                    <SavedListingsLinks style={{ float: 'right' }} />
                    <CategoryTabs />
                    <div style={{ width: '100vw', display: 'grid', gridTemplateColumns: 'auto 325px' }}>
                        <div>
                            <Guts />
                            <CheckThisOut />
                            <div style={{ width: 'auto', display: 'grid', gridTemplateColumns: 'auto auto', gridColumnGap: '25px' }}>
                                {adjacentcounties}
                                <MetroCities />
                            </div>
                        </div>
                        <div style={{ borderLeft: '15px solid', borderColor: 'rgb(244, 244, 244)', width: '325px' }}>Ads go here</div>
                    </div>
                    <div style={{ width: '100vw' }}><Footer /></div>
                </div>
            )
        }
        else {
            let El = pages[this.props.site_page]
            return (<El />)
        }
    }
}

const mapStateToProps = state => {
    return {
        site_page: state.site_page,
        category_id: state.category_id,
        mode: state.mode,
        statecountycitymode: state.statecountycitymode,
        state: state.state,
        county: state.county,
        city: state.city,
    }
}

export default withStyles(styles)(connect(mapStateToProps)(Page))